/// <amd-module name="Build/DesignerExtensions/ExampleCommandPanel/ExamplePanel" />
import * as React from "react";
import { VssComponent } from "VSS/Platform/Layout";
import { Components } from "VSS/Platform/Layout";
import { Button } from "VSSUI/Button";

export interface ExampleCommandPanelProps {
    insertText(text: string, context?: string): void;
    dismiss(): void;
}

export interface ExampleCommandPanelState {

}

export class ExampleCommandPanel extends VssComponent<ExampleCommandPanelProps, ExampleCommandPanelState> {
    constructor(props: ExampleCommandPanelProps) {
        super(props);

        this.state = {
        }
    }

    public render(): JSX.Element {
        return <div className={"example-command-panel"}>
                <Button onClick={this._onClick}>Click Me</Button>
            </div>;
    }

    private _onClick = () => {
        this.props.insertText("Hello", "ExamplePanel");
        this.props.dismiss();
    }
}

Components.add("yaml-example-command-panel", ExampleCommandPanel);
